module.exports = __webpack_public_path__ + "static/media/oci-training.321e1398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oci-training.png
// module id = 540
// module chunks = 0